import * as React from 'react'
import { connect } from 'react-redux'
import {
  insertSectionBlock,
  moveSectionBlock,
} from '@disco/state-management/actions/campaign-editor-actions'
import type { WrapperProps } from './block-drag-wrapper'
import { connectWrapper } from './block-drag-wrapper'

class CustomBlockDragWrapper extends React.Component<WrapperProps> {
  render() {
    const { connectDragPreview, connectDragSource, children } = this.props
    return React.cloneElement(children, {
      connectDragPreview,
      connectDragSource,
    })
  }
}

export default connect(null, {
  insertSectionBlock,
  moveSectionBlock,
})(connectWrapper(CustomBlockDragWrapper)) as any
